module.exports = __webpack_public_path__ + "img/UTFREM-3.fc98a5c0.jpg";